module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_australiansuper-c091917059237a0a917785caf1c9e255.svg";